function filterOpen(container, btn) {
  container.classList.toggle('open');
  btn.classList.toggle('open');

  if (container.classList.contains('open')) {
    container.setAttribute('aria-expanded', 'true');
    jQuery(container).slideDown();
  } else {
    container.setAttribute('aria-expanded', 'false');
    jQuery(container).slideUp();
  }
}

const filterbtn = document.getElementById('eventsFiltersTrigger');
filterbtn.addEventListener('click', function () {
  const container = document.querySelector('.event-filters__container');
  const btn = this;
  filterOpen(container, btn);
});
